<template>
  <div>
    <div
        v-if="isLoading"
        id="loading-bg__cus"
        class="fs-loading__cus"
        style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999999;
      "
    ></div>
    <b-row>
      <b-col class="mb-2 d-flex justify-content-center pyc-header" cols="12">
        {{ detailData && detailData.name }}
      </b-col>
    </b-row>
    <b-card class="col-12" no-body>
      <div class="m-2">
        <b-row>
          <b-col class="d-flex mb-1" cols="4">
            <div style="font-weight: bold; margin-right: 10px">Mức độ khẩn cấp:</div>
            <div style="font-weight: normal">
              {{ isUrgent }}
            </div>
          </b-col>
          <b-col class="d-flex mb-1" cols="4">
            <div style="font-weight: bold; margin-right: 10px">Loại:</div>
            <div style="font-weight: normal">
              {{ type }}
            </div>
          </b-col>
          <b-col class="d-flex mb-1" cols="4">
            <div style="font-weight: bold; margin-right: 10px">Sản phẩm:</div>
            <div style="font-weight: normal">
              {{ campType }}
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="d-flex mb-1" cols="4">
            <div style="font-weight: bold; margin-right: 10px">Thời gian bắt đầu:</div>
            <div style="font-weight: normal">
              {{ startDate }}
            </div>
          </b-col>
          <b-col class="d-flex mb-1" cols="4">
            <div style="font-weight: bold; margin-right: 10px">Thời gian kết thúc:</div>
            <div style="font-weight: normal">
              {{ endDate }}
            </div>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-card class="col-12" no-body>
      <div class="m-2">
        <div v-for="(item, index) in templates" v-if="templates.length > 0" :key="index">
          <div class="title-id">Mẫu số {{ index + 1 }}</div>
          <detail
              :ref="`editModelFormRef${index}`"
              :index="index"
              :initData="item"
              :isAddTemplateBtn="index == templates.length - 1"
              :pycType="detailData && detailData.type ? detailData.type : ''"
              :status="detailData.status"
              @onReloadNotify="getDetailData(detaiId)"
          />
          <div v-if="index != templates.length - 1" class="break-line"></div>
        </div>
      </div>
    </b-card>
    <div class="camp-container">
      <b-col md="12" sm="12">
        <b-row>
          <b-col class="d-flex mb-1" cols="12">
            <div style="font-weight: bold; margin-right: 10px">Được tạo bởi:</div>
            <div style="font-weight: normal">
              {{ detailData ? detailData.createdBy : "" }}
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="d-flex mb-1" cols="12">
            <div style="font-weight: bold; margin-right: 10px">Cập nhập:</div>
            <div style="font-weight: normal">
              {{ detailData ? detailData.updatedDate : "" }}
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="d-flex mb-1" cols="12">
            <div style="font-weight: bold; margin-right: 10px">Trạng thái:</div>
            <div style="font-weight: normal">
              {{ detailData ? detailData.StatusText : "" }}
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="d-flex" cols="12">
            <div class="comment-container">
              <div
                  v-if="!isExpandComment"
                  class="comment-collapsed"
                  @click="isExpandComment = !isExpandComment"
              >
                Bình luận
                <feather-icon icon="ChevronDownIcon"/>
              </div>
              <div
                  v-else
                  class="comment-expand"
                  @click="isExpandComment = !isExpandComment"
              >
                Bình luận
                <feather-icon icon="ChevronDownIcon" style="transform: rotateZ(180deg)"/>
              </div>
              <div v-if="isExpandComment" class="comment-content__container">
                <div class="detail-comment">
                  <div
                      v-for="(item, index) in comments"
                      :key="index"
                      class="main-detail-comment"
                  >
                    <div class="name-info">
                      <div class="avt-comment">
                        <feather-icon icon="UserIcon"/>
                      </div>
                      <div class="name-comment">{{ item.mail }}</div>
                    </div>
                    <div class="text-comment">
                      {{ item.content }}
                    </div>
                  </div>
                </div>
                <div class="bottom-input-comment">
                  <textarea
                      v-model="textCmt"
                      placeholder="Viết bình luận"
                      rows="1"
                      @keypress="onSubmitComment"
                  />
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </div>
    <b-row>
      <b-col class="text-align-right" cols="12">
        <b-button
            v-if="detailData && detailData.isCheck"
            class="btn-icon p-inline-30 mr-2"
            variant="danger"
            @click="onNavigate"
        >Kiểm tra thuê bao
        </b-button
        >
        <b-button
            v-if="detailData && detailData.isRemove"
            class="btn-icon p-inline-30 mr-2"
            variant="danger"
            @click="onOKNavigate"
        >Chuyển
        </b-button
        >
        <b-button
            v-if="detailData && detailData.isApproved"
            class="btn-icon p-inline-30 mr-2"
            variant="danger"
            @click="onAppove"
        >Duyệt
        </b-button
        >
        <b-button
            v-if="detailData && detailData.isApproved"
            class="btn-icon p-inline-30"
            variant="danger"
            @click="onShowCancelModal"
        >Từ chối
        </b-button>
      </b-col>
    </b-row>
    <b-modal
        id="cancel-modal-add-reason"
        body-class="p-0"
        ok-variant="info"
        scrollable
        size="sm"
        title="Lý do từ chối"
        @cancel="reason = ''"
        @close="reason = ''"
        @ok="onCancel"
    >
      <div class="cancel-container">
        <input v-model="reason" type="text"/>
      </div>
    </b-modal>
    <b-modal
        id="navigate-modal"
        body-class="p-0"
        cancelButtonProps="style: { display: 'none'}"
        ok-variant="info"
        scrollable
        size="sm"
        title="Thông báo"
    >
      <template #modal-footer="{ cancel, ok }">
        <b-button variant="info" @click="ok"> OK</b-button>
      </template>
      <div class="cancel-container">
        <!-- <div v-for="(item, idx) in navigateData">
          Mẫu tin {{ idx + 1 }}: Bị trùng {{ item.value }} thuê bao
        </div> -->
        Bạn vui lòng đợi 5' để hệ thống xử lý, sau đó ấn F5 để hiển thị kết quả
      </div>
    </b-modal>
  </div>
</template>
<script>
import {BButton, BCard, BCol, BRow} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Detail from "../detail/detail.vue";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    Detail,
  },
  props: {
    pycType: {
      type: String,
      default: "",
    },
  },
  async mounted() {
    this.detaiId = this.$route.params.id;
    this.getDetailData(this.detaiId);
    this.getComments(this.detaiId);
    this.getInitDropdownData();
  },
  computed: {
    isUrgent() {
      if (this.urgentSelectData.length === 0 || !this.detailData) return "";
      const data = this.urgentSelectData.find(
          (item) => item.id == this.detailData.isUrgent
      );
      if (!data) return "";

      return data.text;
    },
    type() {
      if (this.requestTypeSelectData.length === 0 || !this.detailData) return "";
      const data = this.requestTypeSelectData.find(
          (item) => item.id == this.detailData.type
      );

      if (!data) return "";

      return data.text;
    },
    campType() {
      if (this.dropListSelectData.length === 0 || !this.detailData) return "";
      const data = this.dropListSelectData.find(
          (item) => item.id == this.detailData.campaignType
      );
      if (!data) return "";

      return data.text;
    },
    startDate() {
      if (!this.detailData) return "";

      return this.detailData.startDate;
    },
    endDate() {
      if (!this.detailData) return "";

      return this.detailData.endDate;
    },
  },
  watch: {},
  methods: {
    async getComments(campId) {
      const data = {
        campId,
        page: 1,
        pageSize: 9999999,
      };
      const cmts = await useJwt.post("listComment", data);
      if (cmts.data && cmts.data.result) {
        this.comments = cmts.data.result;
      } else {
        this.comments = [];
      }
    },
    async getDetailData(id) {
      const response = await useJwt.get(`CampDetail/${id}`);
      if (response.data.code === 200) {
        this.detailData = JSON.parse(JSON.stringify(response.data.result));
        if (this.detailData && this.detailData.listNotify != null) {
          this.templates = this.detailData.listNotify;
        }
      } else {
        this.detailData = null;
      }
    },
    async onSubmitComment(evt) {
      if (evt.keyCode == 13 && !evt.shiftKey && this.textCmt.trim().length > 0) {
        const data = {
          content: this.textCmt.trim(),
          requestId: this.detaiId,
        };
        const response = await useJwt.post(`comment`, data);
        if (response.data.code === 200) {
          this.getComments(this.detaiId);
          this.textCmt = "";
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
        }
      }
    },
    async onAppove() {
      var res = await this.$bvModal.msgBoxConfirm("Bạn có chắc chắn muốn duyệt", {
        title: "Duyệt",
        size: "sm",
      });

      if (res) {
        const response = await useJwt.get(`approve/${this.detaiId}`);
        if (response.data.code === 200) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Phiếu yêu cầu đã được duyệt thành công!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
        }
      }
    },
    async onShowCancelModal() {
      this.$bvModal.show("cancel-modal-add-reason");
    },
    async onCancel() {
      const data = {
        id: this.detaiId,
        reason: this.reason,
      };
      this.reason = "";
      const response = await useJwt.post(`rejectPYC`, data);
      if (response.data.code === 200) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Từ chối thành công!",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: response.data.message,
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
      }
    },
    async getInitDropdownData() {
      const urgentData = await useJwt.get("isUrgent");
      if (urgentData.data && urgentData.data.result) {
        this.urgentSelectData = urgentData.data.result.map((item) => ({
          id: item.id,
          text: item.value,
        }));
      }

      const requestTypeData = await useJwt.get("requestType");
      if (requestTypeData.data && requestTypeData.data.result) {
        this.requestTypeSelectData = requestTypeData.data.result.map((item) => ({
          id: item.id,
          text: item.value,
        }));
      }

      const dropListData = await useJwt.get("dropListServices");
      if (dropListData.data && dropListData.data.result) {
        this.dropListSelectData = dropListData.data.result.map((item) => ({
          id: item.id,
          text: item.name,
        }));
      }
    },
    async onNavigate() {
      this.isLoading = true;
      const response = await useJwt.get(`checkPercentNumber/${this.detaiId}`);
      if (response.data.code === 200) {
        this.navigateData = response.data.result;
        this.$bvModal.show("navigate-modal");
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: response.data.message,
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
      }
      this.isLoading = false;
    },
    async onOKNavigate() {
      this.isLoading = true;
      const response = await useJwt.get(`approve/${this.detaiId}`);
      if (response.data.code === 200) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Phiếu yêu cầu đã được chuyển thành công!",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: response.data.message,
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
      }
      this.isLoading = false;
    },
  },
  data() {
    return {
      templates: [],
      detailData: null,
      detaiId: null,
      isExpandComment: false,
      comments: [],
      textCmt: "",
      reason: "",
      urgentSelectData: [],
      requestTypeSelectData: [],
      dropListSelectData: [],
      navigateData: [],
      isLoading: false,
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.modal-activated-order {
  height: 700px;
  color: #000000;
}

.col-700-scroll {
  height: 680px;
  overflow: auto;
}
</style>
<style scoped>
.error-txt small {
  color: red;
}

.unselected {
  background: rgb(175, 175, 175) !important;
  border: rgb(175, 175, 175) !important;
}

.text-end {
  text-align: end;
}

.action-col {
  width: 100%;
  display: flex;
  justify-content: center;
}

.order-id:hover {
  cursor: pointer;
  font-weight: bold;
  color: rgb(34, 100, 243);
}

.detail-custom-table {
  width: 100%;
}

.detail-custom-table {
  display: inline-table;
  border: solid 1px rgb(207 207 207);
}

.detail-custom-table th,
.detail-custom-table td {
  border: solid 1px rgb(207 207 207);
  padding: 5px 10px;
}

.detail-custom-table th {
  vertical-align: baseline;
}

.history-call__header {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.history-call__header h5 {
  margin: 0;
}

.note-question {
  font-style: italic;
  color: rgb(233, 71, 22);
  margin-bottom: 9px;
}

.p-inline-30 {
  padding-inline: 30px !important;
}

.pyc-header {
  font-size: 25px;
  font-weight: bold;
}

.break-line {
  width: 100%;
  height: 1px;
  background: rgb(171, 171, 171);
  margin: 20px 0;
}

.title-id {
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 20px;
}

.no-data {
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: rgba(69, 69, 69, 0.702);
}

.comment-container {
  border: 1px solid rgb(159, 158, 158);
  border-radius: 5px;
  width: 100%;
  margin-bottom: 10px;
}

.comment-collapsed {
  padding: 8px 15px;
  font-weight: bold;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-size: 18px;
}

.comment-expand {
  padding: 8px 15px;
  font-weight: bold;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid rgb(190, 190, 190);
  font-size: 18px;
}

.comment-content__container {
  min-height: 250px;
  display: flex;
  flex-direction: column;
}

.detail-comment {
  height: 0;
  flex-grow: 1;
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  overflow-y: scroll;
  padding: 0px 5px 5px 10px;
}

.detail-comment::-webkit-scrollbar {
  width: 8px;
}

/* Track */
.detail-comment::-webkit-scrollbar-track {
  background: white;
}

/* Handle */
.detail-comment::-webkit-scrollbar-thumb {
  background: rgb(184, 184, 184);
  border-radius: 50px;
  cursor: pointer;
}

/* Handle on hover */
.detail-comment::-webkit-scrollbar-thumb:hover {
  background: rgb(131, 131, 131);
  border-radius: 50px;
  cursor: pointer;
}

.bottom-input-comment {
  border-top: 1px solid rgb(190, 190, 190);
  padding: 8px;
  width: 100%;
}

.bottom-input-comment > textarea {
  width: 100%;
  height: 40px;
  outline: none;
  padding: 3px 8px;
  border: 1px solid rgb(190, 190, 190);
  border-radius: 3px;
  resize: none;
}

.bottom-input-comment > textarea::placeholder {
  color: rgb(194, 193, 193);
}

.main-detail-comment {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  margin-bottom: 15px;
}

.name-info {
  display: flex;
  align-items: center;
}

.top-avt {
  height: 100%;
  display: flex;
  align-items: flex-start;
}

.avt-comment {
  width: 30px;
  height: 30px;
  margin-right: 5px;
  border-radius: 50%;
  border: 1px solid rgb(188, 188, 188);
  display: flex;
  justify-content: center;
  align-items: center;
}

.name-comment {
  font-weight: bold;
  flex-grow: 1;
  width: 0;
}

.text-comment {
  border-radius: 4px;
  border: 1px solid rgb(187, 186, 186);
  margin-top: 5px;
  padding: 5px 8px;
}

.camp-container {
  position: fixed;
  z-index: 2;
  top: 240px;
  right: 25px;
  width: 450px;
  background: white;
  padding: 15px 8px;
  border-radius: 15px;
  border: 1px solid rgb(187, 186, 186);
}

.cancel-container {
  width: 100%;
  padding: 20px;
}

.cancel-container > input {
  width: 100%;
  padding: 5px 10px;
  font-size: 15px;
  outline: none;
  border-radius: 4px;
  border: 1px solid #dfdfdf;
}

.fs-loading__cus {
  display: none;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: #111;
  opacity: 0.7;
  z-index: 1000;
}

.fs-loading__cus::after {
  content: "";
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -25px 0 0 -25px;
  width: 50px;
  height: 50px;
  border-left: 3px solid #e91c27;
  border-top: 3px solid #e91c27;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  -webkit-animation: rotate360 1.5s infinite;
  animation: rotate360 1.5s infinite linear;
  z-index: 1000;
}

#loading-bg__cus {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: block;
  position: absolute;
  z-index: 99999;
}
</style>
